import React, { Component } from 'react';
import {connect} from 'react-redux';
import createSelector from 'helpers/createSelector';
import { fetchLatestFeed, latesClickMediaType } from '../actions';
import _ from 'lodash';
import classnames from 'classnames';
import {Row, Col} from 'antd';
import MediaTypeItem from './MediaTypeItem';
import './style.css';

const container = connect(
  createSelector(
    (state) => ({
      subjects: _.get(state, 'subject.entities'),
      panel_row2: _.get(state, 'subject.panel_row2'),
      checkMediaType: _.get(state, 'home.mediaType'),
    })
    ,
    (state) => {
      const {subjects, panel_row2, checkMediaType} = state;
      const subjectId = _.get(panel_row2, 'data[0]')
      const subject = subjects[subjectId]
      const mediaTypes = _.keys(_.get(subject, 'queries'))
      return {
        mediaTypes,
        checkMediaType
      }
    }
  )
)

class MediaTypeList extends Component {

  componentDidMount() {
    const { dispatch, mediaTypes } = this.props;
    dispatch(latesClickMediaType(_.head(mediaTypes)))
  }

  render() {
    const { mediaTypes, checkMediaType, dispatch } = this.props;
    return (
      <div>
        {_.map(mediaTypes, (mediaType, i) =>{
          return (
            <MediaTypeItem onClick={()=>{
                  localStorage.defaultMediaType = action.query.mediaType;
              }} index={i} mediaType={mediaType} checkMediaType={checkMediaType} dispatch={dispatch}/>
          )
        })}
      </div>
    )
  }
}

export default container(MediaTypeList)



/** WEBPACK FOOTER **
 ** ./src/app/modules/home/components/MediaTypeList.js
 **/